<template>
  <div style="margin-top: 50px">
    <div class="listProposals">
      <h3>Aree di miglioramento</h3>
      <div
        style="margin-top: 20px"
        class="row"
        v-for="(proposalChart, index) in proposals"
        :key="index"
      >
        <div class="col-4" v-if="permission > 1">
          <label>Item di valutazione</label>
          <select
            class="form-control"
            v-model="proposalChart.level_id"
            @change="updateProposal(index, proposalChart)"
          >
            <option
              v-for="level in all_levels"
              :value="level.id"
              :key="level.id"
            >
              {{ level.name }}
            </option>
          </select>
        </div>
        <div class="col-1" v-else></div>
        <div class="col-4">
          <label>Azione proposta</label>
          <select
            class="form-control"
            v-model="proposalChart.proposal_id"
            @change="updateProposal(index, proposalChart)"
          >
            <option
              v-for="proposal in all_proposals"
              :value="proposal.id"
              :key="proposal.id"
            >
              {{ proposal.name }}
            </option>
          </select>
        </div>
        <div class="col-3">
          <label>Note</label>
          <textarea
            style="max-height: 100px !important"
            v-model="proposalChart.comment"
            class="form-control"
            @change="updateProposal(index, proposalChart)"
          ></textarea>
        </div>
        <div class="col-1">
          <button
            style="margin-bottom: -50px"
            type="button"
            class="btn btn-primary"
            @click="deleteProposal(index)"
          >
            Elimina
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div style="margin-bottom: 50px" class="newProposal" v-if="permission > 1">
      <h4>Inserisci nuova azione proposta</h4>

      <div class="row">
        <div class="col-4">
          <label>Item di valutazione</label>
          <select class="form-control" v-model="newProposalLevel">
            <option
              v-for="level in all_levels"
              :value="level.id"
              :key="level.id"
            >
              {{ level.name }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <label>Azione proposta</label>
          <select class="form-control" v-model="newProposal">
            <option
              v-for="proposal in all_proposals"
              :value="proposal.id"
              :key="proposal.id"
            >
              {{ proposal.name }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <button
            style="margin-bottom: -50px"
            type="button"
            class="btn btn-primary"
            @click="addProposal()"
          >
            Aggiungi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
export default {
  mounted() {
    this.getLevelFactorsProposals();
  },
  props: {
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    all_proposals: {
      type: Array,
      required: true,
    },
    all_levels: {
      type: Array,
      required: true,
    },
    permission: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      proposals: [],
      newProposalLevel: "",
      newProposal: "",
      newComment: "",
      //default      
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    updateProposal(index, row) {
      let proposal = {
        proposal_id: row.proposal_id,
        level_id: row.level_id,
        comment: row.comment,
      };
      axios
        .put(
          "/update-level-factor-proposals-chart" +            
            "/" +
            this.evaluation_chart_id +
            "/" +
            this.question_survey_id,
          { proposal: proposal, proposalIndex: index },
        )
        .then((response) => {
          this.getLevelFactorsProposals();
        });
    },
    deleteProposal(index) {
      axios
        .delete(
          "/delete-level-factor-proposals-chart" +            
            "/" +
            this.evaluation_chart_id +
            "/" +
            this.question_survey_id,
          { params: { proposalIndex: index } },
        )
        .then((response) => {
          this.getLevelFactorsProposals();
        });
    },

    addProposal() {
      let proposalNew = {
        proposal_id: this.newProposal,
        level_id: this.newProposalLevel,
        comment: "",
      };
      axios
        .post(
          "/store-level-factor-proposals-chart" +            
            "/" +
            this.evaluation_chart_id +
            "/" +
            this.question_survey_id,
          { proposal: proposalNew },
        )
        .then((response) => {
          this.getLevelFactorsProposals();
        });
    },

    getLevelFactorsProposals() {
      axios
        .get(
          "/level-factor-proposals-chart" +            
            "/" +
            this.evaluation_chart_id +
            "/" +
            this.question_survey_id,
        )
        .then((response) => {
          this.proposals = response.data;
          console.log(this.proposals);
        });
    },
  },
};
</script>
